import { render, staticRenderFns } from "./FacturacionForm.vue?vue&type=template&id=bbfea5fe"
import script from "./FacturacionForm.vue?vue&type=script&lang=js"
export * from "./FacturacionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports